<div class="wrapper">
    <button #columnSelectorToggle class="column-picker" matTooltip="Column Picker" mat-icon-button
            (click)="arrangeColumns()">
        <mat-icon>view_column</mat-icon>
    </button>
    <table mat-table [dataSource]="tableDataContainer" class="full-width" matSort
           [matSortActive]="sortColumnId ? sortColumnId : ''" [matSortDirection]="sortDirection ? sortDirection : 'asc'"
           matSortDisableClear cdkDropList [cdkDropListSortingDisabled]="true">

        <!--- Note that these columns can be defined in any order.
              The actual rendered columns are set as a property on the row definition" -->

        <ng-container *ngFor="let column of displayedColumns" matColumnDef="{{column.field}}">
            <mat-header-cell *matHeaderCellDef mat-sort-header
                             [ngClass]="{'skinny': isSkinnyColumn(column), 'med-skinny': isMedSkinnyColumn(column), 'lrg-skinny': isLargeSkinnyColumn(column)}"> {{column.title}} </mat-header-cell>
            <mat-cell [cardImageTooltip]="dataItem" *matCellDef="let dataItem"
                      [ngClass]="{'skinny': isSkinnyColumn(column), 'med-skinny': isMedSkinnyColumn(column), 'lrg-skinny': isLargeSkinnyColumn(column)}"
                      (click)="column.isInput || onRowClicked(dataItem)">
                <ng-container *ngIf="column.isInput; else dataTypeCheck">
                    <ng-container *ngIf="column.dataType === 'number'">
                        <mat-form-field class="number-input">
                            <input matInput type="number" [value]="dataItem[column.field]"
                                   (change)="onInputChanged($event.target.value, dataItem, column)">
                        </mat-form-field>
                    </ng-container>
                    <ng-container *ngIf="column.dataType === 'quality'">
                        <div class="quality-input">
                            <mat-form-field>
                                <mat-select value="{{dataItem[column.field]}}" (selectionChange)="onInputChanged($event.value, dataItem, column)">
                                    <mat-option
                                            *ngFor="let quality of ['Mint', 'Near Mint', 'Excellent', 'Good', 'Light Played', 'Played', 'Poor']"
                                            [value]="quality">{{quality}}</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="column.dataType === 'boolean'">
                        <mat-checkbox [checked]="dataItem[column.field]"
                                      (change)="onInputChanged($event.checked, dataItem, column)"></mat-checkbox>
                    </ng-container>
                </ng-container>
                <ng-template #dataTypeCheck>
                    <ng-container *ngIf="column.dataType === 'cardset'; else mana">
                        <ng-container
                                *ngIf="(cardSymbologyUtils.getCardSet(dataItem[column.field], dataItem['rarity']) | async) as cardSetAndSafeSvg">
                            <div [matTooltip]="dataItem['setName']" [innerHTML]="cardSetAndSafeSvg.safeSvg"
                                 class="{{dataItem['rarity']}}"></div>
                        </ng-container>
                    </ng-container>
                </ng-template>
                <ng-template #mana>
                    <ng-container *ngIf="column.dataType === 'mana'; else color">
                        <img *ngFor="let manaSymbol of cardSymbologyUtils.getManaSymbols(dataItem, column.field) | async"
                             class="mana-symbol"
                             [matTooltip]="manaSymbol.english"
                             [alt]="manaSymbol.english"
                             [src]="manaSymbol.svgUri"/>
                    </ng-container>
                </ng-template>
                <ng-template #color>
                    <ng-container *ngIf="column.dataType === 'color'; else boolean">
                        <img *ngFor="let colorSymbol of cardSymbologyUtils.getSymbols(dataItem[column.field]) | async"
                             class="mana-symbol"
                             [matTooltip]="colorSymbol.english"
                             [alt]="colorSymbol.english"
                             [src]="colorSymbol.svgUri"/>
                    </ng-container>
                </ng-template>
                <ng-template #boolean>
                    <ng-container *ngIf="column.dataType === 'boolean'; else cardText">
                        <mat-checkbox [checked]="dataItem[column.field]" [disabled]="true"></mat-checkbox>
                    </ng-container>
                </ng-template>
                <ng-template #cardText>
                    <ng-container *ngIf="column.field === 'oracleText'; else timestamp">
                        <div [innerHTML]="getCardText(dataItem) | async"></div>
                    </ng-container>
                </ng-template>
                <ng-template #timestamp>
                    <ng-container *ngIf="column.dataType === 'timestamp'; else length">
                        {{dataItem[column.field] | date:'medium'}}
                    </ng-container>
                </ng-template>
                <ng-template #length>
                    <ng-container *ngIf="column.dataType === 'length'; else plainData">
                        {{dataItem[column.field].length}}
                    </ng-container>
                </ng-template>
                <ng-template #plainData>{{dataItem[column.field]}}</ng-template>
            </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="columnIds"></mat-header-row>
        <mat-row class="data-row" *matRowDef="let item; columns: columnIds;"
                 (contextmenu)="onRowContext($event, item)" mat-ripple cdkDrag [cdkDragData]="item"
                 [ngClass]="{'invalid': !isValid(item)}">
            <img *cdkDragPreview class="card"
                 [src]="item.images.normal ? item.images.normal : 'https://via.placeholder.com/250x349?text=No Image Available'"
                 alt="Card">
            <div *cdkDragPlaceholder></div> <!-- this hides the placeholder in the receiving drop list -->
        </mat-row>
    </table>
</div>